module.exports = "/assets/home-page/media/rzeczpospolita.png?Y8kYdJV";